'use client';

import { Container } from './Overlay.styled';
import CircularProgress from '@mui/material/CircularProgress';
import { useAppSelector } from '../../hooks/reduxHooks';

const Overlay = () => {
  const loading = useAppSelector((st) => st.loading);
  const auth = useAppSelector((st) => st.auth);

  if (!loading && !auth?.loading) return null;

  return (
    <Container>
      <CircularProgress size={60} sx={{ color: 'white' }} />
    </Container>
  );
};
export default Overlay;
